import ApiService from "@/core/services/api.service";

const actions = {
  /**
   *
   * @param context
   * @param payload
   * @returns {*}
   */
  registerSchoolHoliday(context, payload) {
    ApiService.setHeader();
    return ApiService.post("school/holiday/management", payload).then(
      (response) => response
    );
  },
};

export default {
  actions,
};
